import React, { useEffect } from 'react';
import { useAds } from 'hooks/use-ads';
import { ProductImpressionData } from '../product-impression.interface';

const ProductDetailImpression: React.FC<{ product: ProductImpressionData; }> = ({
    product
}) => {
    const ads = useAds();
    const disabled = !ads || !ads.adpConfig || !ads.adpConfig.actgid || !ads.adpConfig.adpNetwork;

    useEffect(() => {
        if (disabled === false) {
            setTimeout(() => {
                window?.onetAds?.cmd.push((onetAds): void => onetAds.sendActivityEvent({
                    network: ads?.adpConfig?.adpNetwork ?? '',
                    actgid: ads?.adpConfig?.actgid ?? '',
                    event: 'product_detail',
                    products: [{
                        name: product.name,
                        id: String(product.id),
                        price: String(product.price),
                        brand: product.producer?.name,
                        category: product.category.name,
                        qty: 1
                    }],
                    sitetype: 'product'
                }));
            }, 200);
        }
    }, [product]);

    return null;
};

export default ProductDetailImpression;
